import { defaultAxios, constants } from "../data/httpWithAxios";
import qs from "qs";

export default {
  login: function(loginAccount) {
    loginAccount.vendors = JSON.stringify(loginAccount.vendors);
    return defaultAxios(
      constants.contentType.application_form_urlencoded,
      false
    )
      .post("/rc/cs/web/corp/login", qs.stringify(loginAccount))
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  getUser: function(req) {
    return defaultAxios(constants.contentType.application_json)
      .post("/rc/cs/web/corp/user/me", req)
      .then(response => {
        return response;
      });
  },
  loginForBMW: function(loginAccount) {
    return defaultAxios(
      constants.contentType.application_form_urlencoded,
      false
    )
      .post("/rc/cs/web/corp/loginForBMW", qs.stringify(loginAccount))
      .then(response => {
        return response;
      });
  },
  loginForKIA: function(loginAccount) {
    return defaultAxios(constants.contentType.application_form_urlencoded)
      .post("/rc/cs/web/corp/loginForKIA", qs.stringify(loginAccount))
      .then(response => {
        return response;
      });
  },
  getInfo: function(corpNo) {
    return defaultAxios(constants.contentType.application_json)
      .get("/rc/cs/web/corp/user", {
        params: {
          corpNo: corpNo
        }
      })
      .then(response => {
        return response;
      });
  },
  modifyPassword: function(password) {
    let params = {
      passwd: password
    };
    return defaultAxios(constants.contentType.application_form_urlencoded)
      .post("/rc/cs/web/corp/updatePassword", qs.stringify(params))
      .then(response => {
        return response;
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/user.js